import { render, staticRenderFns } from "./SatellitePopup.vue?vue&type=template&id=1d0d1e78&scoped=true&"
import script from "./SatellitePopup.vue?vue&type=script&lang=js&"
export * from "./SatellitePopup.vue?vue&type=script&lang=js&"
import style0 from "./SatellitePopup.vue?vue&type=style&index=0&id=1d0d1e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d1e78",
  null
  
)

export default component.exports